export default function ImproveSkills(){
    const list = [
        "Learn new recipes",
        "Experiment with food",
        "Write your own recipes",
        "Know nutrition facts",
        "Get cooking tips",
        "Get ranked"
    ]

    return (
        <div className="section improve-skills">
            <div className="col img">
                <img src="/img/gallery/img_10.jpg" alt="" />
            </div>
            <div className="col typography">
                <h1 className="title">Improve Your Culinary Skills</h1>
                {
                    list.map((item, i)=>{
                        return <p className="skill-item"  key={i}>{item}</p>
                    })
                }
                <button className="btn">singup now</button>
            </div>
        </div>
    )
}